export const ASSETS = {
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/7be5ac22eb9ac6a4_Amanda%E2%80%99s%20Neon%20Coffee%20Arcade%20Crest.jpg",
  ownerJonathan: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/d98aca1b81bdf142_32253735_10157164298937814_8564948173078921216_n.jpg",
  ownerDee: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/0c985ed539b9c576_653907632_26739626495631104_4418970040316821726_n.webp",
  dogOtisLola: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/2adb481052fe977b_Screenshot%202026-10-18%20at%209.42.07%E2%80%AFAM.png",
  dogBaylee: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/20eb536d9aa30a87_Screenshot%202026-10-18%20at%209.41.06%E2%80%AFAM.png",
};

export const BRAND = "Amanda's Coffee & Retro Video Games";

export const IMAGES = {
  craftEspresso: "https://images.unsplash.com/photo-1507915135761-41a0a222c709?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxiYXJpc3RhJTIwcG91cmluZyUyMGxhdHRlJTIwYXJ0fGVufDB8fHx8MTc5MjI4NDc0M3ww&ixlib=rb-4.1.0&q=85",
  retroArcade: "https://images.unsplash.com/photo-1531594896955-305cf81269f1?q=85&w=1200&auto=format&fit=crop",
  inclusiveTeam: "https://images.pexels.com/photos/36729736/pexels-photo-36729736.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cafeInterior: "https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/eab86d4a381369a7_IMG_1028.webp",
  neighborhoodMap: "https://images.unsplash.com/photo-1708685889314-013b9afd452f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxjaXR5JTIwbWFwJTIwaWxsdXN0cmF0aW9ufGVufDB8fHx8MTc5MjI4NDc0M3ww&ixlib=rb-4.1.0&q=85",
  coffeeBeans: "https://images.unsplash.com/photo-1675306408031-a9aad9f23308?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxyb2FzdGVkJTIwY29mZmVlJTIwYmVhbnN8ZW58MHx8fHwxNzkyMjg0NzQzfDA&ixlib=rb-4.1.0&q=85",
};

export const Logo = ({ className = "w-8 h-8" }) => (
  <svg className={`${className} text-[#E25C38]`} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <rect x="3" y="3" width="26" height="26" rx="6" stroke="currentColor" strokeWidth="2.5" fill="#FAF6EE" />
    <rect x="7" y="10" width="8" height="3" rx="1.5" fill="currentColor" />
    <circle cx="21" cy="11.5" r="2.5" fill="currentColor" />
    <path d="M10 20C12 23 20 23 22 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export const Grain = ({ id }) => (
  <svg className="grain-layer" aria-hidden="true">
    <filter id={id}>
      <feTurbulence type="fractalNoise" baseFrequency="0.75" stitchTiles="stitch" />
    </filter>
    <rect width="100%" height="100%" filter={`url(#${id})`} />
  </svg>
);
